var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDownload = function SvgDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 0C6.3125 0 6 0.34375 6 0.75V6H3.25C2.6875 6 2.40625 6.6875 2.8125 7.09375L7.5625 11.8438C7.78125 12.0625 8.1875 12.0625 8.40625 11.8438L13.1562 7.09375C13.5625 6.6875 13.2812 6 12.7188 6H10V0.75C10 0.34375 9.65625 0 9.25 0H6.75ZM16 11.75C16 11.3438 15.6562 11 15.25 11H10.6562L9.125 12.5312C8.5 13.1875 7.46875 13.1875 6.84375 12.5312L5.3125 11H0.75C0.3125 11 0 11.3438 0 11.75V15.25C0 15.6875 0.3125 16 0.75 16H15.25C15.6562 16 16 15.6875 16 15.25V11.75ZM12.125 14.5C12.125 14.8438 11.8438 15.125 11.5 15.125C11.1562 15.125 10.875 14.8438 10.875 14.5C10.875 14.1562 11.1562 13.875 11.5 13.875C11.8438 13.875 12.125 14.1562 12.125 14.5ZM14.125 14.5C14.125 14.8438 13.8438 15.125 13.5 15.125C13.1562 15.125 12.875 14.8438 12.875 14.5C12.875 14.1562 13.1562 13.875 13.5 13.875C13.8438 13.875 14.125 14.1562 14.125 14.5Z",
    fill: "#303A5F"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download.d4e4f125.svg";
export { ForwardRef as ReactComponent };